<template>
  <AuthWrapper>
    <p class="auth-notice">
      Non hai un account?
      <router-link to="/auth/register">Registrati</router-link>
    </p>
    <div class="auth-contents">
      <a-form @finish="handleSubmit" :model="formState" :rules="rules" layout="vertical">
        <sdHeading as="h3">
          Accedi ad <span class="color-secondary">A.MA.LI</span>
        </sdHeading>
        <a-form-item has-feedback name="username" label="E-mail">
          <a-input type="email" v-model:value="formState.username" />
        </a-form-item>
        <a-form-item has-feedback name="password" label="Password">
          <a-input
            type="password"
            v-model:value="formState.password"
            placeholder="Password"
          />
        </a-form-item>
        <div class="auth-form-action">
          <a-checkbox @change="onChange">Ricordami</a-checkbox>
          <router-link class="forgot-pass-link" to="/auth/forgotPassword">
            Hai dimenticato la password?
          </router-link>
        </div>
        <a-form-item>
          <sdButton
            class="btn-signin"
            htmlType="submit"
            type="primary"
            size="large"
            style="background-color: #F29100"
          >
            {{ isLoading ? "Loading..." : "Accedi" }}
          </sdButton>
        </a-form-item>
      </a-form>
    </div>
  </AuthWrapper>
</template>
<script>
import { computed, reactive, ref, defineComponent } from "vue";
import { useStore } from "vuex";
import { AuthWrapper } from "./style";
import axios from "axios";
import {useRouter} from "vue-router";
import {useToast} from "vue-toast-notification";

const SignIn = defineComponent({
  name: "SignIn",
  components: { AuthWrapper },
  setup() {
    const { state, dispatch } = useStore();
    const router = useRouter();
    const isLoading = computed(() => state.auth.loading);
    const checked = ref(null);
    const toast = useToast();

    const rules = {
        username: [{ required: true, trigger: 'change', type: 'email', message: "Inserire un indirizzo email valido" }],
        password: [{ required: true, trigger: 'change' }],
    };
    const handleSubmit = async () => {
        await axios.post(process.env.VUE_APP_API_ENDPOINT + '/login', formState)
          .then(async (response) => {
              await localStorage.setItem('user', JSON.stringify(response.data.user));
              await localStorage.setItem('token', response.data.access_token);
              await router.push({name: 'dashboard'});
              await dispatch('login')
          })
          .catch(() => {
              toast.error('Utente e password non corretti!')
          })
    };
    const onChange = (checked) => {
      checked.value = checked;
    };
    const formState = reactive({
      username: "",
      password: "",
    });
    return {
      isLoading,
      checked,
      handleSubmit,
      onChange,
      formState,
      rules
    };
  },
});

export default SignIn;
</script>
